export default {
        methods: {
            openModalDeletePartner(item) {
                let title = 'Вы действительно хотите удалить партнера?'
                this.MODAL({
                    name: 'ModalAgreement',
                    title,
                    onComplete: () => {
                        // //api
                        this.removePartner(item);
                    },
                })
            },
            openModalDeleteService(item) {
                let title = 'Вы действительно хотите удалить услугу?'
                this.MODAL({
                    name: 'ModalAgreement',
                    title,
                    onComplete: () => {
                        // //api
                        this.removeService(item);
                    },
                })
            },
            openModalDeleteNews(item) {
                let title = 'Вы действительно хотите удалить новость?'
                this.MODAL({
                    name: 'ModalAgreement',
                    title,
                    onComplete: () => {
                        // //api
                        this.removeNews(item);
                    },
                })
            },
            openModalDeleteCatalog(item) {
                let title = 'Вы действительно хотите удалить каталог?'
                this.MODAL({
                    name: 'ModalAgreement',
                    title,
                    onComplete: () => {
                        // //api
                        this.removeCatalog(item);
                    },
                })
            },

            openModalDeleteMaterial(item) {
                let title = 'Вы действительно хотите удалить материал?'
                this.MODAL({
                    name: 'ModalAgreement',
                    title,
                    onComplete: () => {
                        //api
                        this.removeMaterial(item);
                    },
                })
            },
            openModalDeleteCompetencies(item) {
                let title = 'Вы действительно хотите удалить компетенцию?'
                this.MODAL({
                    name: 'ModalAgreement',
                    title,
                    onComplete: () => {
                        // //api
                        this.removeCompetencies(item);
                    },
                })
            },

            openModalDeleteUser(item) {
                let title = 'Вы действительно хотите удалить пользователя?'
                this.MODAL({
                    name: 'ModalAgreement',
                    title,
                    onComplete: () => {
                        // //api
                        this.removeUser(item);
                    },
                })
            },

            openModalDeleteTags(item) {
                let title = 'Вы действительно хотите удалить тег?'
                this.MODAL({
                    name: 'ModalAgreement',
                    title,
                    onComplete: () => {
                        // //api
                        this.removeTag(item);
                    },
                })
            },


            openModalDropPassword(item) {
                let title = 'Вы действительно сбросить пароль этому пользователю?'
                this.MODAL({
                    name: 'ModalAgreement',
                    title,
                    onComplete: () => {
                        // //api
                        this.dropPassword(item);
                    },
                })
            },
        }
    }
